// extracted by mini-css-extract-plugin
module.exports = {"root":"card-title-module--root--16-c-","shieldBlank":"card-title-module--shieldBlank--25Ztp"};